export default __webpack_public_path__ + "static/media/webinar.1ba97e03.png";